import { Spinner, SpinnerProps } from '../Spinner/Spinner';
import styles from './BlockWrapperWithSpinner.module.scss';
import cx from 'classnames';

type Props = SpinnerProps & {
  transparent?: boolean;
  topLayer?: boolean;
  noBorderRadius?: boolean;
};

export const BlockWrapperWithSpinner = ({
  transparent = false,
  topLayer = false,
  noBorderRadius = false,
  ...spinnerProps
}: Props) => (
  <div
    className={cx(styles.container, {
      [styles.isTransparent]: transparent,
      [styles.topLayer]: topLayer,
      [styles.noBorderRadius]: noBorderRadius,
    })}>
    <Spinner {...spinnerProps} />
  </div>
);
